export const pageTitle = (title) => {
  return (document.title = title + " - Aurnima Technology Pvt Ltd IT Solutions");
}